import React from 'react';

/**
 * เนื้อหาในหัวคอลัมน์ตาราง — คอลัมน์ที่เรียงได้ต้องเป็นปุ่มจริง (BUG-S2281-002)
 *
 * เดิมผูก onClick ไว้ที่ <th> ตรง ๆ → กด Tab ไปไม่ถึง กด Enter ไม่ได้ ผู้ใช้คีย์บอร์ด/screen reader เรียงข้อมูลไม่ได้เลย
 * ใช้คู่กับ aria-sort บน <th> (ascending/descending/none)
 */
interface SortHeaderContentProps {
  sortable: boolean;
  onSort: () => void;
  children: React.ReactNode;
}

const SortHeaderContent: React.FC<SortHeaderContentProps> = ({ sortable, onSort, children }) => {
  if (!sortable) {
    return <div className="flex items-center gap-1">{children}</div>;
  }
  return (
    <button
      type="button"
      onClick={onSort}
      className="flex items-center gap-1 w-full text-left font-semibold rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
    >
      {children}
    </button>
  );
};

export default SortHeaderContent;
